// extracted by mini-css-extract-plugin
export default {"dropdown":"index_dropdown_HwPUQ","flag":"index_flag_a9tI1","menuIcon":"index_menuIcon_XPE5u"};